import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { UpsertPrivateMutationVariables } from '@school_ify/schoolify-repository/src/shared/types';

import EditProfileService from '../../domain/services/editProfile';
import AuthService from '../../domain/services/authentication';

interface UserProfileState {
  error: string;
  loading: 'idle' | 'pending' | 'success' | 'failed';
  userPrivateData: any;
  userData: any;
}

export const fetchUserPrivateData = createAsyncThunk(
  'editProfile/fetchUserPrivateData',
  async () => {
    try {
      return await EditProfileService.getUserPrivateData();
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const upserUserData = createAsyncThunk(
  'editProfile/upserUserData',
  async (data: UpsertPrivateMutationVariables) => {
    try {
      await EditProfileService.updateUserData(data);
      const userData = await AuthService.getMe();
      const userPrivateData = await EditProfileService.getUserPrivateData();
      return {
        userData,
        userPrivateData,
      };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const getUserFullData = createAsyncThunk('editProfile/getUserFullData', async () => {
  try {
    return await AuthService.getMe();
  } catch (error) {
    throw new Error(error);
  }
});

const initialState = {
  loading: 'idle',
  userPrivateData: null,
  userData: null,
} as UserProfileState;

const userProfileSlice = createSlice({
  name: 'userProfileSlice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchUserPrivateData.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(fetchUserPrivateData.fulfilled, (state, action) => {
      state.loading = 'success';
      state.userPrivateData = action.payload;
    });
    builder.addCase(fetchUserPrivateData.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
    builder.addCase(upserUserData.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(upserUserData.fulfilled, (state, action) => {
      state.loading = 'success';
      state.userPrivateData = action.payload.userPrivateData;
      state.userData = action.payload.userData;
    });
    builder.addCase(upserUserData.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
    builder.addCase(getUserFullData.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(getUserFullData.fulfilled, (state, action) => {
      state.loading = 'success';
      state.userData = action.payload;
    });
    builder.addCase(getUserFullData.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});

export const selectUserPrivateData = state => state.userProfile.userPrivateData;
export const selectUserData = state => state.userProfile.userData;
export const selectLoading = state => state.userProfile.loading;

export default userProfileSlice.reducer;
